import React from 'react'
import styled from 'styled-components'

import { Button, Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { ChevronUpDownGroupIcon } from '@root/shared/ui-kit'

import { NotificationWidgetTxBody } from './notification-widget-tx-body'

import type { NotificationWidgetVariant } from '../../model'
import type { Transaction } from '@root/entities/transaction'

type Props = {
  txs: Array<Transaction.Transaction>
  variant: NotificationWidgetVariant
}

export const NotificationWidgetTx: React.FC<Props> = ({ txs, variant }) => {
  const { t } = useTranslation()

  return (
    <Root data-variant={variant}>
      <Heading>
        <Label>{t('transactions')}</Label>
        {variant === 'row' ? (
          <Label style={{ textTransform: 'lowercase' }}>
            {t('common.all')}
          </Label>
        ) : (
          <SettingsButton
            variant="ghost"
            size="h28"
            iconLeft={<ChevronUpDownGroupIcon />}
            radius="rounded"
          />
        )}
      </Heading>
      <Separator />
      <NotificationWidgetTxBody txs={txs} />
    </Root>
  )
}

const Root = styled.div`
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  padding: 3px;

  display: grid;
  grid-template-rows: auto auto 1fr;
`

const Heading = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;

  gap: 4px;
  padding: 10px;
  padding-bottom: 6px;
`

const Label = styled(Typography).attrs({
  variant: 'body3-medium',
  component: 'span',
})`
  color: var(--text-9);
`

const Separator = styled.div`
  opacity: 0.34;
  background: var(--backgroundA-3);
  display: grid;
  height: 1px;
  margin-inline: 4px;
  margin-bottom: 4px;
`

const SettingsButton = styled(Button)`
  color: var(--text-9);
`
